import { render, staticRenderFns } from "./ItkNew.vue?vue&type=template&id=07fc50ba&"
import script from "./ItkNew.vue?vue&type=script&lang=js&"
export * from "./ItkNew.vue?vue&type=script&lang=js&"
import style0 from "./ItkNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports